import { STORAGE_PREFIXES, readStorageValue, writeStorageValue } from './storageKeys';

export const STEPPER_STEPS = ['documents', 'extraction', 'evidence', 'assembled', 'preview', 'export'];

const getStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.localStorage || null;
};

export const getStepIndex = (stepId) => STEPPER_STEPS.indexOf(stepId);

export const areAllModulesCompleted = (report) => {
  const modules = report?.modules;
  if (!Array.isArray(modules) || modules.length === 0) {
    return false;
  }
  return modules.every((module) => module.status === 'completed' || module.status === 'locked');
};

export const getStoredMaxStepIndex = (reportId) => {
  if (!reportId) {
    return 0;
  }
  const storage = getStorage();
  if (!storage) {
    return 0;
  }
  try {
    const rawValue = readStorageValue(storage, STORAGE_PREFIXES.reportStepperProgress, { suffix: reportId });
    const parsedValue = Number.parseInt(rawValue?.value, 10);
    return Number.isFinite(parsedValue) ? parsedValue : 0;
  } catch (error) {
    return 0;
  }
};

export const setStoredMaxStepIndex = (reportId, maxStepIndex) => {
  if (!reportId || !Number.isFinite(maxStepIndex)) {
    return;
  }
  const storage = getStorage();
  if (!storage) {
    return;
  }
  try {
    writeStorageValue(storage, STORAGE_PREFIXES.reportStepperProgress, String(maxStepIndex), { suffix: reportId });
  } catch (error) {
    // Ignore storage errors (private mode, quota, etc.)
  }
};

export const advanceStoredStep = (reportId, stepId) => {
  if (!reportId) {
    return 0;
  }
  const stepIndex = getStepIndex(stepId);
  if (stepIndex === -1) {
    return getStoredMaxStepIndex(reportId);
  }
  const currentIndex = getStoredMaxStepIndex(reportId);
  const nextIndex = Math.max(currentIndex, stepIndex);
  setStoredMaxStepIndex(reportId, nextIndex);
  return nextIndex;
};
